module.exports = __webpack_public_path__ + "img/Uneven Plating.95d506ad.png";